export function encodeUrlToRouter(url) {
  if (typeof url !== 'string')
    return url;

  return url.replace(/\//g, '%2F');
}

export function encodeUrlFromRouter(url) {  
  if (typeof url !== 'string')
    return url;

  return url.replace(/%2F/g, '\\');
}

